// SECTIONS

import {
    constables
} from './base.js';

const breakpoint = constables().breakpoint;

const times = constables().times;
const timem = constables().timem;
const timel = constables().timel;

// INIT

export function initanimate() {

    routes();

}

function routes() {

    let stroke = document.querySelectorAll('.animation-stroke svg');
    stroke.forEach(s => {

        prepareStroke(s);

    });

}

function easeOutCubic(x) {
    return 1 - Math.pow(1 - x, 3);
}

export function prepareStroke(svg) {

    let paths = svg.querySelectorAll('path');
    let step = 60;
    let ratio = 1;
    let border = "var(--border-handwriting)";
    if (paths) {

        let vw = svg.getBoundingClientRect().width;
        let svw = parseInt(svg.dataset.width);
        ratio = vw / svw;

        if (svg.classList.contains('slow')) {

            step = 25;
            border = "var(--border-manuskript)";

        }

        let animation = {
            ratio: ratio,
            step: step,
            layer: 0,
            end: paths.length,
            point: 0,
            border: 0,
            length: paths[0].getTotalLength()
        }
        paths[0].classList.add('start');



        window.requestAnimationFrame(startStroke);

        function startStroke() {
            if (animation.layer < animation.end) {

                paths[animation.layer].setAttribute('style', `stroke-dasharray:${animation.length*animation.ratio};stroke-dashoffset:${(animation.length - animation.point)*animation.ratio};stroke-width:calc(${border}*${animation.border});`);

                if (animation.point >= animation.length) {
                    paths[animation.layer].setAttribute('style', `stroke-dasharray:none;stroke-dashoffset:none;`);
                    animation.layer++;
                    if (animation.layer < animation.end) {
                        animation.point = 0;
                        animation.length = paths[animation.layer].getTotalLength();
                        paths[animation.layer].setAttribute('style', `stroke-dasharray:${animation.length};stroke-dashoffset:${animation.length};`);
                        paths[animation.layer].classList.add('start');
                    }
                }

                animation.point += animation.step;
                animation.border = easeOutCubic(animation.point / animation.length);

                window.requestAnimationFrame(startStroke);

            }

        }

    }

}